export default __webpack_public_path__ + "static/media/Icon.2cd46bdf.svg";